





































































import {Component, Vue} from "vue-property-decorator";
import XXHeader from "@/views/KeShangAdmin/XXHeader.vue";
import {QingApp} from "@/entity/QingApp";
import {QingAppDto} from "@/dto/QingAppDto";
import {getModule} from "vuex-module-decorators";
import {AuthStore} from "@/oauth/AuthStore";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {ConsumerLightAppRelationReq} from "@/entity/ConsumerLightAppRelationReq";
import {ConsumerLightAppRelationEntity} from "@/entity/ConsumerLightAppRelationEntity";
import {ConsumerLightAppRelationDto} from "@/dto/ConsumerLightAppRelationDto";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import { QingAppRelationInfo } from "@/entity/QingAppRelationInfo";
import {CompanyInfo} from "@/entity/CompanyInfo";

@Component({
  components: {XXHeader},
})

export default class CommonlyUsedSettings extends Vue {
  tab = 'home';
  ls = getModule(AuthStore);
  isManage = false;
  private qingApps: QingApp[] = [];
  private newQingApps: QingApp[] = [];
  su = SecurityUtils;

  fanghui() {
    this.$router.go(-1)
  }

  get id() {
    return this.$route.params.id;
  }

  add(q: QingApp, index: number) {
    this.qingApps.splice(index, 1);
    this.newQingApps.push(q)
  }

  deleteQingApp(q: QingApp, index: number) {
    const name = q.appName
    this.qingApps.push(this.newQingApps[index])
    this.newQingApps.splice(index, 1)

  }

  async saveQingApp() {
    if (this.newQingApps.length == 0) {
      this.$q.notify({message: '至少选择一个轻应用:', color: 'red'});
    } else {
      const consumerLightAppRelationReq = new ConsumerLightAppRelationReq()
      consumerLightAppRelationReq.userName = this.ls.loginUser.username
      for (let i = 0; i < this.newQingApps.length; i++) {
        const consumerLightAppRelationEntity = new ConsumerLightAppRelationEntity()
        consumerLightAppRelationEntity.lightAppId = this.newQingApps[i].id as unknown as string
        consumerLightAppRelationEntity.lightAppSort = (i + 1).toString()
        consumerLightAppRelationReq.consumerLightAppRelationEntityList.push(consumerLightAppRelationEntity)
      }
      console.log(consumerLightAppRelationReq)
      const res = await ConsumerLightAppRelationDto.saveRelationInfo(consumerLightAppRelationReq) as any
      this.$q.notify({message: res.resMsg, color: 'green'});
    }

  }

  keShangSelect1() {
    this.$router.push({name: 'keShangSelect1'});
  }

  keShangSelect2() {
    this.$router.push({name: 'keShangSelect2'});
  }

  async getQingAppList() {
    const qingApp = new QingApp();
    const userApp = new QingApp();
    userApp.userName = this.ls.loginUser.username
    const userApps = await QingAppDto.findAll(userApp)
    this.newQingApps = userApps
    let qingApps = await QingAppDto.findAll(qingApp);
    if (!this.isManage) {
      qingApps = qingApps.filter(q => {
        switch (q.showType) {
          case 0:
            return true;
          case 1:
            return q.showUser.some(value => value === this.su.getToken().getUsername());
          case 2:
            return q.showCustomer.some(value => value === this.id);
          case 3:
            return q.showRole.some(value => this.su.getTokenAuthorities().some(value1 => value === value1));
        }
      });
    }
    for (let i = 0; i < qingApps.length; i++) {
      for (let j = 0; j < userApps.length; j++) {
        if (qingApps[i].appName === userApps[j].appName) {
          qingApps.splice(i, 1);
        }
      }
    }
    this.qingApps = qingApps;
  }

  async getQueryRelationInfo(){
    const qingAppRelationInfo = new QingAppRelationInfo()
    qingAppRelationInfo.userName =this.ls.loginUser.username
    /*
    const userInfoEntity = JSON.parse(localStorage.getItem("demo1") as  any) as UserInfoEntity
     qingAppRelationInfo.companyId = userInfoEntity.companyId
     */
    const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
    qingAppRelationInfo.companyId = companyInfo.companyId;
    const  a = await ConsumerLightAppRelationDto.queryRelationInfo(qingAppRelationInfo)
    this.newQingApps = a
    console.log(a)
  }
  async queryRelationInfoNotCommon(){
    const qingAppRelationInfo = new QingAppRelationInfo()
    qingAppRelationInfo.userName =this.ls.loginUser.username
    /*
    const userInfoEntity = JSON.parse(localStorage.getItem("demo1") as  any) as UserInfoEntity
     qingAppRelationInfo.companyId = userInfoEntity.companyId
     */
    const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
    qingAppRelationInfo.companyId = companyInfo.companyId;
    const a =await ConsumerLightAppRelationDto.queryRelationInfoNotCommon(qingAppRelationInfo)
    this.qingApps=a
  }

  async mounted() {
    await this.getQueryRelationInfo()
    await this.queryRelationInfoNotCommon()
  }
}
